/**
 * RESPONSIBILITY: preview the pastor's note, closing the About page toward Leadership.
 *
 * The note is faded off rather than cut to a chosen sentence: a fixed excerpt needs
 * rewriting every time the letter does, and a fade needs nothing when it does.
 */
import { Html } from '@framework/react';
import type { LeadershipNoteSection } from '@app/sections';
import { Picture } from '../commons/Picture';
import { Page, hrefFor } from '../commons/pages';

export function AboutLeaderTeaser({ c }: { c: LeadershipNoteSection }) {
  if (!c.noteHtml) return null;

  return (
    <section className="band band-centre about-leader-band">
      <div className="wrap about-leader-wrap">
        {c.eyebrow && <span className="about-kicker">{c.eyebrow}</span>}
        <Picture value={c.notePortrait} alt={c.notePortrait?.alt} className="about-leader-portrait" />
        {c.noteHeading && <h2 className="about-h2">{c.noteHeading}</h2>}
        <div className="about-excerpt">
          <Html className="md-body">{c.noteHtml}</Html>
        </div>
        {c.moreLabel && (
          <div className="btns btns-centre">
            <a className="btn btn-ghost" href={hrefFor(Page.Leadership)}>{c.moreLabel}</a>
          </div>
        )}
      </div>
    </section>
  );
}
